import { ProjectBase } from '../components/ProjectBase';
import { ProjectInterface } from '../pages/Projects';
import { ProjectType } from "src/components/ProjectType";

import cover from "../assets/img/gdstd3.webp";
import { Col } from 'react-bootstrap';
import { renderTextBlock } from 'src/components/RenderTextBlocks';


export const projectDetails: ProjectInterface = {
    url: "gdstd3",
    title: "Gamedev Study 3",
    summary: "A simple recreation of the board game Quarto in Unity3D.",
    description: `This is a simple recreation of the board game Quarto in Unity that was actually meant to be a fully-fleshed out project but it turned out to be just a study subject for online gaming and networking.
    
    Since I shut down the game server I don't see a point in publishing a demo/release, but you always can build it from a [clone](https://github.com/lucasctnh/gdstd-3-unity) and play on your own server.`,
    year: "2021",
    tags: ["Strategy", "Multiplayer", "Study Project", "Unity"],
    imageSrc: cover,
    hasVideo: false,
    startVideoTime: 0,
    videoSrc: "",
    isCoverType: true,
    projectType: ProjectType.STUDY,
    haveTags: true,
    roles: ["Multiplayer Programmer", "Study"],
    technologies: ["Unity", "C#", "Mirror"],
    collaborators: ["Lucas Coutinho"],
    highlightColor: "#60151F",
    descriptionTitle: "A multiplayer Quarto experiment in Unity",
    linkData:
        [
            { type: 'github', url: "https://github.com/lucasctnh/gdstd-3-unity" },
            { type: 'text', url: "https://github.com/lucasctnh/gdstd-3-unity" },
        ],
    relatedProjects: ["GDSTD4", "GDSTD1", "CheckMore"],
};


export function GDSTD3() {
    return (
        <div>
            <ProjectBase project={projectDetails}
                useCarousel={false}
                isLeftFirst={false}
                leftContent={
                    <Col size={12} md={12} className="a-body-left" style={{ marginTop: "0" }}>

                        <div className="a-subtitle">
                            Afterthoughts
                        </div>

                        <div className="a-body-description">
                            {renderTextBlock(`It all began with the thought that I wanted to do a online game so I could play along with my friends and also practice newly adquire knowledge on networking from my [last study project](https://lucasctnh.com/Game-Dev-Study-Prototype-2-1a949382760444cea7242d2696b4a2ec?pvs=21). So, while brainstorming ideas I stumbled across the board game Quarto and I thought it would be easy to implement so I went with it. 🤭

I realized it was a bad choice for my purpose right on my first play test because it was only two players and the fun was on being strategic and trying to think ahead of your opponent, that's when I realized that I actually wanted a party game, where you it play casually with the game acting as a catalyst for the fun you'd already been having by just chatting with a group of friends. This was one of the reasons to drop it.

As for a more technical aspect, I had two goals for the network connection: I wanted it to be peer-to-peer; and I wanted it to work with WebGL. However, I didn't want to use Noble Connect again because I thought it abstracted too much, this time I wanted to setup my own relay server. 🌐

I also wanted to test Unity's netcode, MLAPI, but since it didn't support WebGL I stuck with Mirror. I then set up a listen server using Amazon's EC2 and [LRM](https://github.com/Derek-R-S/Light-Reflective-Mirror).

I have to say I loved LRM, although it was still an abstraction it met everything I wanted to do and it was pretty easy to use and understand. It was truly a finding, I was almost changing my plans and restarting the whole project to use another netcode solution. 😮‍💨

Well, in the end I didn't finish it. One of the reasons I already said, the other one was that I was doing [another project](https://lucasctnh.com/Street-Racing-9c46ab27d4564255b346e5c3f40da606?pvs=21) in parallel to it. I had various problems with that other project that consequently affected this one as well, and when I decided to put this one in hold to come back later I lost the interest. Still, maybe someday I'll come back to it cuz I had some different ideas that I think it would be cool to implement.`)}
                        </div>
                    </Col>
                }
                rightContent={
                    null
                }>
            </ProjectBase>
        </div>
    );
}